<template>
  <div class="login">
    <img class= "imgthermo" src="http://www.suypro.es/img/logo-header-default.png" >
    <h3>Asignar ID de dispositivo</h3>
    <input type="text" v-model="id" placeholder="ID"><br>
    <input type="text" v-model="descripcion" placeholder="Descripción"><br>
    
    <button @click="asignar">Asignar</button>
    
  </div>
</template>
<script>
import firebase from 'firebase';
export default {
    name: 'asigdevice',
    data() {
      return {
        id: '',
        descripcion:''
        
      }
    },
     methods: {
      asignar: function() {
           let user = firebase.auth().currentUser;
            let url = "usuarios/" + user.uid
            firebase.database().ref(url).set({
              device1: this.id
            }
            ).then( 
              firebase.database().ref("devices/"+this.id+"/reles/descripcion").set(this.descripcion).then(
              this.$store.commit("SetThermo", this.id),
              this.$router.push({path: '/thermo'})
            ))
      }
    },
}
</script>
<style scoped>
  input {
    margin: 10px 0;
    width: 60%;
    padding: 15px;
  }
  button {
    margin-top: 20px;
    width: 40%;
    cursor: pointer;
  }
</style>

